export const ROUTES = {
  DASHBOARD: "/dashboard",
  SIGNUP: "/signup",
  MARKETPLACE_REGISTER: "/marketplace", // marketplace upon register + default marketplace target URL
  MARKETPLACE_LOGIN: "/login/marketplace", // marketplace upon login
  FEDERATED_LOGIN_LINK: "/login/federated", // federated login
  FEDERATED_LOGIN_CALLBACK: "/login/federated/callback", // federated login callback
  VERIFY: "/verify",
  VERIFICATION_RECOVERY: "/verification/recover",
  PASSWORD_RESET: "/password/reset",
  USERNAME_RECOVERY: "/username/recover",
  INVITES: "/invites",
  INVOICES: "/invoices",
  SCHEDULES: "/schedules",
  IMAGES: "/images",
  PROJECTS: "/projects",
  PROJECT_WIZARD: "/project-wizard",
  RESOURCES: "/resources",
  USERS: "/users",
  ACCOUNTS: "/account",
  SSH_KEYS: "/account/ssh-keys",
  DOCUMENTATION: "https://sherpa.docs.escape-technology.com",
  SUPPORT: "https://support.escape-technology.com"
};
